import { keccak256 } from "@ethersproject/keccak256";
import { toUtf8Bytes } from "@ethersproject/strings";
export function id(text) {
    return keccak256(toUtf8Bytes(text));
}
//# sourceMappingURL=id.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/hash/lib.esm/id.js
// module id = null
// module chunks = 